import { useEffect, useState } from "react";
import LabelInput from "../../../Component/labelInput";
import PageTitle from "../../../module/pageTitle";
import { Submitbtn } from "../../../Component";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import {
  getCategoryList,
  getProductTypeList,
} from "../../Admin/adminSlice";
import moment from "moment";
import DropdownWithClear from "../../../Component/dropdownWithClear";
import AdminTable from "../../../Component/adminTable";
// import { getCouponTypeList, getTransactionDetails } from "../cxoSlice";
import DatePicker from "../../../Component/datePicker";
import { getDamageStock } from "../../Publication/publicationSlice";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";
const DamageStock = () => {
  const dispatch: Function = useDispatch<AppDispatch>();
  const [productTypeList, setProductTypeList] = useState<any>([]);
  const [productType, setProductType] = useState<any>("");
  const [category, setCategory] = useState<any>("");
  const [categoryList, setCategoryList] = useState<any>([]);
  const [startDate, setStartDate] = useState<any>(
    moment.utc(new Date()).format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState<any>(
    moment.utc(new Date()).format("YYYY-MM-DD")
  );
  const [damageStockList, setDamageStockList] = useState<any>([]);

  useEffect(() => {
    const postData = {
      startDate: startDate,
      endDate: endDate,
    };
    dispatch(
      getDamageStock({
        params: postData,
        callback: (res: any) => {
          if (res?.status === "success") {
            setDamageStockList(res?.data);
            dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
            setTimeout(() => {
              dispatch(hideSnackbar());
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }));
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        },
      })
    );
    dispatch(
      getProductTypeList({
        callback: (res: any) => {
          setProductTypeList(res?.data);
        },
        errorCallback: () => { },
      })
    );



  }, []);

  const onchangeProductType = (value: any) => {
    setProductType(value);
    const postData = {
      productTypeId: value?._id,
    };
    dispatch(
      getCategoryList({
        params: postData,
        callback: (res: any) => {
          setCategoryList(res);
        },
        errorCallback: (error: any) => { },
      })
    );
  };
  const onchangeCategory = (value: any) => {
    setCategory(value);

  };
  const onchangeStartDate = (value: any) => {
    setStartDate(value);
  };
  const onchangeEndDate = (value: any) => {
    setEndDate(value);
  };


  const handleSubmit = (e: any) => {
    e.preventDefault();
    const postData = {
      startDate: startDate,
      endDate: endDate,
      productTypeId: productType?._id,
      productCategoryId: category?._id,
    };
    dispatch(
      getDamageStock({
        params: postData,
        callback: (res: any) => {
          if (res?.status === "success") {
            setDamageStockList(res?.data);
            dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
            setTimeout(() => {
              dispatch(hideSnackbar());
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }));
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        },
      })
    );

  };
  const validations = () => {
    let valid = false;
    if (startDate === "" || endDate === "") {
      valid = true;
    }

    return valid;
  };

  const renderTable = () => {
    return (
      <div className="mt-4">
        <AdminTable
          tableData={damageStockList ? damageStockList : []}
          pagename={"damageStockList"}
          tableHead={[
            "S.N",
            "Product",
            "Product Type",
            "Category",
            "Damage Stock",
          ]}
        />
      </div>
    );
  };
  let sum: any = 0;
  for (let i = 0; i < damageStockList.length; i++) {
    sum += damageStockList[i].Amount;
  }
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle name={"Damage Stock"} />
      </div>
      <div className="formDiv">
        <div className="bxshadow p-2 borderRadius mb-4 ">
          <form onSubmit={handleSubmit}>
            <div className="row align-items-center">
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Start Date"} isRequired />
                <DatePicker
                  setInputText={(value: any) => {
                    onchangeStartDate(value);
                  }}
                  value={startDate}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"End Date"} isRequired />
                <DatePicker
                  setInputText={(value: any) => {
                    onchangeEndDate(value);
                  }}
                  value={endDate}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Product Type"} />
                <DropdownWithClear
                  labelName={"Select Product Type"}
                  setInputText={(value: any) => onchangeProductType(value)}
                  options={productTypeList}
                  value={productType}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Category"} />
                <DropdownWithClear
                  labelName={"Select Product category "}
                  setInputText={(value: any) => onchangeCategory(value)}
                  options={categoryList}
                  value={category}
                />
              </div>
              <div className="col-md-2 mb-3 pt-4">
                <Submitbtn name={"Search"} disabled={validations()} />
              </div>
            </div>
          </form>
        </div>

        <div className="bxshadow borderRadius p-1">
          <div>{renderTable()}</div>
        </div>
      </div>
    </div>
  );
};

export default DamageStock;
